import React from 'react';

const TxtBaseXL = ({ children }) => {
    return (
        <div className='font-bold text-lg text-primary-darkHighlight-s1l1 dark:text-primary-lightHighlight-s1l1'>
            {children}
        </div>
    );
};

export default TxtBaseXL